// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1iwgA","large":"styles_large__WCq61"};